'use client';

import { useState, useEffect } from 'react';

/**
 * Custom hook to safely get the current URL with SSR safety checks
 * @returns The current URL or empty string during SSR
 */
export const useCurrentUrl = (): string => {
  const [currentUrl, setCurrentUrl] = useState<string>('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  return currentUrl;
};
